import * as types from '../types';
import initialState from './initialState';

export default function sessionTimeoutReducer(state = initialState.sessionTimeout, action) {
  switch (action.type) {
    case types.SESSION_TIMEOUT_FULFILLED: {
      return action.payload.data;
    }
    case types.SESSION_TIMEOUT_REJECTED: {
      return null;
    }
    case types.LOGOUT_FULFILLED: {
      return null;
    }
    default:
      return state;
  }
}
